import { Button, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import FloatingResourceContainerFooter from 'components/containers/FloatingResourceContainerFooter';
import ParagraphText from 'components/text/ParagraphText';

import useData from './hooks/useData';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const FloatingResourceAddMenu = ({
    defaultAssetType,
    defaultResource,
    onClose,
    openRequest,
    testId = TEST_ID
}: Props) => {
    const {
        handleBackToMenu,
        handleRequestClose,
        handleSelectResource,
        menuOptions,
        selectedResource
    } = useData({
        defaultAssetType,
        defaultResource,
        onClose,
        openRequest
    });

    return (
        <VerticalContainer className={styles.floatingResourceAddMenu} testId={testId}>
            {!selectedResource && (
                <Grid className={styles.grid}>
                    {menuOptions.map(({ label, value }) => (
                        <Button
                            className={styles.button}
                            key={label}
                            onClick={() => handleSelectResource(value)}>
                            <ParagraphText className={styles.paragraphText} text={`+ ${label}`} />
                        </Button>
                    ))}

                    <Wrapper className={styles.placeholder} />
                </Grid>
            )}

            {selectedResource && selectedResource.renderComponent()}

            <FloatingResourceContainerFooter
                onBack={handleBackToMenu}
                onClose={handleRequestClose}
                resource={selectedResource?.value || null}
            />
        </VerticalContainer>
    );
};

export default FloatingResourceAddMenu;
